import type { ListItem } from "../../components/List/List"
import { Promotions } from "../Promotion/Promotions"
import { MemoryClass } from "./MemoryClass"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { DayOfWeekLabels } from "../../Enum/EDayOfWeek"
import i18next from "i18next"

export class PromotionsMemory extends MemoryClass<Promotions> {
  setList = (promotionsList: Promotions[]) => {
    this.listData = promotionsList
  }

  protected cloneEntity(item: Promotions): Promotions {
    return new Promotions({ ...item })
  }

  getListCards = (all: boolean): ListItem[] => {
    const cards: ListItem[] = []

    let count = 0

    this.listData.forEach((ss) => {
      if (all || ss.status === EEnableStatusType.Active) {
        cards.push(this.getCard(ss, count))
      }
      count++
    })

    return cards
  }

  protected getItemId(item: Promotions): number {
    return item.id
  }

  getCard(ss: Promotions, count: number): ListItem {
    const enable = ss.status === EEnableStatusType.Active
    const hasTimeWindow = Boolean(ss.startTime || ss.endTime)
    const appliesEveryDay = ss.dayOfWeek.length === 0
    const isPercentage = ss.percentage > 0

    const timeFinish =
      ss.endTime === null ? "" : `${i18next.t("dateTimeSelector:label_final")} ${ss.endTime.slice(0, 5)}`

    const timeStart =
      ss.startTime === null ? "" : `${i18next.t("dateTimeSelector:label_begin_final")} ${ss.startTime.slice(0, 5)}`

    const finalTime = (timeStart + " " + timeFinish).trim()

    return {
      isDisable: !enable,
      id: ss.id,
      title: ss.name,
      linkImage: "",
      index: count,
      dataFilter: [
        ss.name,
        ss.genderType.toGenderTypeString(),
        ss.status.toEnableStatusTypeString(),
        ss.percentage.toString(),
        ss.fixedValue.toString(),
        appliesEveryDay ? "todos os dias" : `${ss.dayOfWeek.length} dia(s)`,
      ],
      children: (
        <div
          className={`
          flex flex-col gap-3
          p-4
          rounded-2xl
          transition-all duration-300
          ${
            enable
              ? "bg-gradient-to-r from-orange-50 to-white hover:shadow-lg hover:scale-[1.01]"
              : "bg-gray-100 opacity-70"
          }
        `}
        >
          <div className="flex justify-between items-start">
            <div>
              <span className="text-lg font-bold text-gray-800">{ss.name}</span>

              <p className="text-sm text-gray-500 mt-1 line-clamp-2">
                {ss.description || i18next.t("components:label_no_description")}
              </p>
            </div>

            {enable ? (
              <span className="px-3 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-700">Ativa</span>
            ) : (
              <span className="px-3 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-600">Inativa</span>
            )}
          </div>

          <div className="flex items-center justify-between">
            <span className="text-2xl font-extrabold text-orange-600">{ss.getValueToStringMoney()}</span>

            <div className="flex gap-2 flex-wrap">
              {finalTime.length > 0 && (
                <span className="px-2 py-1 text-xs rounded-full bg-red-100 text-red-600 font-medium">
                  ⏰ {finalTime}
                </span>
              )}

              <span className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-700 font-medium">
                {ss.genderType.toGenderTypeString()}
              </span>

              <span className="px-2 py-1 text-xs rounded-full bg-indigo-100 text-indigo-700 font-medium">
                {isPercentage ? "Percentual" : "Valor fixo"}
              </span>
            </div>
          </div>
        </div>
      ),

      body: (
        <div className="px-4 pb-4">
          <div className="border-t border-gray-200 pt-3 flex flex-wrap gap-2">
            {appliesEveryDay && (
              <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-700 font-medium">
                Todos os dias
              </span>
            )}

            {!hasTimeWindow && (
              <span className="px-2 py-1 text-xs rounded-full bg-amber-100 text-amber-700 font-medium">
                Sem restrição de horário
              </span>
            )}

            {ss.dayOfWeek.map((day, index) => (
              <span key={index} className="px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-600">
                {i18next.t(`dateTimeSelector:days.${DayOfWeekLabels[day]}`)}
              </span>
            ))}
          </div>
        </div>
      ),
    }
  }
}
